// Email Service Configuration
export const emailConfig = {
  // SMTP2GO API Configuration
  apiUrl: 'https://api.smtp2go.com/v3/email/send',
  apiKey: 'api-50D8BEA4A27A443EA1B53008F228F6A2',
  sender: 'excel.advance@gmail.com',
  
  // Email Templates
  templates: {
    leadConfirmation: {
      subject: (userFullName, preferredLoanType) => `HBFC Loan Inquiry - ${userFullName} - ${preferredLoanType}`,
      textBody: (userDetails) => {
        const { fullName, email, phoneNumber, netIncome, age, city, preferredLoanType } = userDetails;
        const currentDate = new Date().toLocaleDateString('en-GB', { 
          day: '2-digit', 
          month: 'long', 
          year: 'numeric' 
        });
        const uniqueReferenceId = `HBFC-${Date.now().toString().slice(-6)}`;
        
        return `Dear ${fullName},

Thank you for your interest in HBFC Home Finance. We have successfully received your loan inquiry and our team will get back to you shortly.

Here are the details you provided:

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
INQUIRY DETAILS
━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

Full Name:           ${fullName}
Email Address:       ${email}
Phone Number:        ${phoneNumber}
Monthly Net Income:  PKR ${netIncome}
Age:                ${age} years
City/Location:       ${city}
Preferred Loan Type: ${preferredLoanType}

Inquiry Date:        ${currentDate}
Reference ID:        ${uniqueReferenceId}

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

WHAT HAPPENS NEXT?

✓ Our loan specialist will review your inquiry within 2-3 business days
✓ We will contact you via phone or email to discuss your requirements
✓ You will receive personalized loan options based on your profile
✓ Our team will guide you through the complete application process

IMPORTANT INFORMATION:

• Keep your Reference ID (${uniqueReferenceId}) for future correspondence
• Prepare your documents as our team will guide you on requirements
• Our current markup rates start from 11.5% (subject to approval)
• Maximum financing available up to 85% of property value

CONTACT INFORMATION:

📞 Phone: +92-21-111-111-111
📧 Email: info@hbfc.com.pk
🌐 Website: www.hbfc.com.pk
🕒 Working Hours: Monday to Friday, 9 AM to 5 PM

FOLLOW US:
Stay updated with our latest offers and financial tips on our social media channels.

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

This is an automated confirmation email. Please do not reply to this email address.
For any immediate assistance, please contact us using the information provided above.

Thank you for choosing HBFC Home Finance.

Best regards,
HBFC Customer Service Team
HBFC Home Finance`;
      }
    }
  }
};

// Email sending service
export const sendEmail = async (toEmail, template, userDetails = {}) => {
  try {
    // Generate subject and body based on template type
    let subject, textBody;
    
    if (template === 'leadConfirmation' && userDetails) {
      subject = emailConfig.templates[template].subject(userDetails.fullName, userDetails.preferredLoanType);
      textBody = emailConfig.templates[template].textBody(userDetails);
    } else {
      // Fallback for other templates or if userDetails not provided
      subject = typeof emailConfig.templates[template].subject === 'function' 
        ? emailConfig.templates[template].subject('Valued Customer', 'Loan Inquiry')
        : emailConfig.templates[template].subject;
      textBody = typeof emailConfig.templates[template].textBody === 'function'
        ? emailConfig.templates[template].textBody(userDetails || {})
        : emailConfig.templates[template].textBody;
    }

    const emailData = {
      sender: emailConfig.sender,
      to: [toEmail],
      subject: subject,
      text_body: textBody,
      api_key: emailConfig.apiKey
    };

    const response = await fetch(emailConfig.apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(emailData)
    });

    const result = await response.json();
    
    if (response.ok) {
      console.log('Email sent successfully:', result);
      return { success: true, data: result };
    } else {
      console.error('Email sending failed:', result);
      return { success: false, error: result };
    }
  } catch (error) {
    console.error('Email service error:', error);
    return { success: false, error: error.message };
  }
}; 